<template>
    <button class="btn btn-sm btn-primary my-1 py-2 px-1" v-on:click="handleClick" v-html="buttonText">
    </button>
</template>

<script>
import VueTypes from 'vue-types'
import moment from 'moment';

export default {
    mounted() {},
    methods: {
        handleClick() {
            this.$emit('book-resource', this.startDate, this.maxSlotDuration, this.headquarterId);
        },
    },
    data() {
        return {};
    },
    props: {
        headquarterId: VueTypes.number,
        startDate: VueTypes.string,
        endDate: VueTypes.string,
        maxSlotDuration: VueTypes.number,
    },
    computed: {
        filterHeadquarter: function() {
            return this.$parent.$parent.filterHeadquarter;
        },
        headquarters: function() {
            return this.$parent.$parent.headquarters;
        },
        headquarter: function() {
            return this.headquarters[this.headquarterId] ?? [];
        },
        buttonText: function() {
            let buttonText = moment(this.startDate).format("HH:mm");
            if (!this.filterHeadquarter && Object.keys(this.headquarters).length > 1) {
                buttonText += "<br/><div class='pt-2'><small class='font-weight-bold'>" + (this.headquarter.abbreviation ?? this.headquarter.name) + "</small></div>";
            }

            return buttonText;
        },
    },
    filters: {
    },
};
</script>

<style>
.card-image img {
    max-height: 160px;
}
</style>
